import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = ['Actividades listas para usar', 'Proyectos de aula completos', 'Evaluaciones incluidas', 'Rúbricas listas para Primaria y Secundaria', 'Fichas imprimibles', 'Recursos para el docente', 'Historia del Arte y Arte Argentino', 'Acceso inmediato'];
export function Includes() {
  return <section className="py-24 lg:py-32 bg-brand-800 text-paper-card relative overflow-hidden" data-id="element-138">
      {/* Subtle organic shapes for editorial feel */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-700/40 rounded-full blur-[120px] pointer-events-none" data-id="element-139"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-serif font-medium mb-6 leading-tight tracking-tight text-white" data-id="element-142">
            Todo lo que recibís en un solo lugar
          </h2>
          <p className="text-lg text-brand-100 font-normal" data-id="element-143">
            Un sistema completo. Sin archivos sueltos, sin buscar en mil
            carpetas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-brand-700/50 backdrop-blur-sm rounded-[20px] p-8 md:p-14 border border-brand-600/30" data-id="element-144">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-6" data-id="element-145">
            {features.map((f, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04,
            duration: 0.8,
            ease: 'easeOut'
          }} className="flex items-center gap-4 py-4 border-b border-brand-600/30 last:border-0 sm:[&:nth-last-child(2)]:border-0" data-id="element-146">
                <div className="w-8 h-8 rounded-full bg-accent-100 text-brand-500 flex items-center justify-center shrink-0" data-id="element-147">
                  <Check className="w-4 h-4" strokeWidth={2} data-id="element-148" />
                </div>
                <span className="font-medium text-white text-base lg:text-lg" data-id="element-149">
                  {f}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}